import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/index.js
// module id = 674
// module chunks = 0